import styles from './Availability.module.scss';

const Availability = ({ product }) => {
    if (product?.availability) {
        return <span className={`${styles.availability} ${styles.available}`}>{product?.storeStatus?.messageAvailable}</span>
    }

    return <span className={`${styles.availability} ${styles.unavailable}`}>{product?.storeStatus?.messageUnavailable}</span>
}
export default Availability;
